
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor-registration",
      function () {
        return require("private-next-pages/vendor-registration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor-registration"])
      });
    }
  